import { SvgClose } from "icons/SvgClose"

export const AlertDashboard = ({ statics, status }: any) => {


    return (
        <>
            {status != 'success_in_challenge' && status != null &&
                <div className="w-full min-h-[50px] px-2 mb-2 bg-red-300 rounded border-l-4 border-red-500 flex items-center overflow-hidden">
                    <div className="w-full text-sm py-2 text-justify">
                        {statics?.daily_loss_target_status != null &&
                            <span>{statics?.daily_loss_target_status?.description}</span>
                        }
                        {statics?.total_loss_target_status != null &&
                            <span>{statics?.total_loss_target_status?.description}</span>
                        }
                    </div>
                </div >
            }

            {/* {statics?.is_current_target_sign == true && status == null &&
                <div className="w-full min-h-[50px] px-2 mb-2 bg-green-300 rounded border-l-4 border-green-500 flex items-center overflow-hidden">
                    <div className="w-full text-sm py-2 text-justify">
                        تبریک خدمت شما بابت پشت سر گذاشتن این مرحله از چالش. برای فعال سازی مرحله بعدی لطفا تیکت درخواست خود را ثبت نمایید.
                    </div>
                </div>
            } */}

            {statics?.is_current_target_sign == true && status == 'success_in_challenge' &&
                <div className="w-full min-h-[50px] px-2 mb-2 bg-green-300 rounded border-l-4 border-green-500 flex items-center overflow-hidden">
                    <div className="w-full text-sm py-2 text-justify">
                        معامله گر گرامی ضمن تبریک موفقیت شما در گذاران چالش این مرحله. ستارگان ترید برای شما آرزوی موفقیت روز افزون دارد.
                    </div>
                </div>
            }
        </>
    )
}